import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubscriptionPlanRoutingModule } from './subscription-plan-routing.module';
import { SubscriptionPlanComponent } from './subscription-plan.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PaymentGateWayModule } from 'src/app/pages/payment-gate-way/payment-gate-way.module';


@NgModule({
  declarations: [
    SubscriptionPlanComponent
  ],
  imports: [
    CommonModule,
    SubscriptionPlanRoutingModule,
    FlexLayoutModule,
    PaymentGateWayModule
  ],
  exports:[
    SubscriptionPlanComponent
  ]
})
export class SubscriptionPlanModule { }
